export enum EPaymentStatus {
    Pending = 1,
    Approved = 2,
    NotApproved = 3
}